module.exports = __webpack_public_path__ + "img/blacklogo.de8cdd76.png";